/**
 * Stringify and dedupe organization ids for form values / API payloads.
 */
export const normalizeOrganizationIds = (
  organizationIds: (number | string)[]
): string[] => Array.from(new Set(organizationIds.map(String)))

/**
 * Merge the next autocomplete selection with previously selected orgs the
 * actor is not allowed to remove (orgs outside their membership).
 */
export const resolveOrganizationIds = ({
  actorOrganizationIds,
  isAdminWriterUser,
  nextIds,
  previouslySelectedIds,
}: {
  actorOrganizationIds: ReadonlySet<string>
  isAdminWriterUser: boolean
  nextIds: string[]
  previouslySelectedIds: string[]
}): string[] => {
  const lockedSelectedIds = isAdminWriterUser
    ? []
    : previouslySelectedIds.filter(
        (organizationId) => !actorOrganizationIds.has(organizationId)
      )

  return normalizeOrganizationIds([...nextIds, ...lockedSelectedIds])
}
